import useSWR from 'swr'
import { Filter } from '../common/types/calendar'
import { convertColumns, Row } from '../options/convertColumns'
import fetchColumns from '../options/fetchColumns'
import { useAuth } from '../../hooks/use-auth'

type Response = {
  isError: boolean
  isLoading: boolean
  columns: Filter[] | undefined
}

const useColumns = (): Response => {
  const auth = useAuth();
  const { data, error } = useSWR<Row[] | undefined>('/api/columns', () => fetchColumns(auth.authorizationHeader, auth.factoryId))
  const columns = convertColumns(data || [])

  return {
    columns: columns,
    isError: !!error,
    isLoading: !error && !data,
  }
}

export default useColumns
